import type { SharePerson, ShareRole } from '../../collaboration/share/source';
import type { TranslationKey } from '../../i18n/I18n';

export type ParticipantAction = 'follow' | 'unfollow' | 'promote' | 'demote' | 'remove';

/**
 * The ••• menu of a participant's card (the app's `RemotePlayerActionsMenu`, with Follow first): the owner also gets
 * the role toggle and Remove access for a member the Share list lets them manage; an agent is only followed.
 */
export function participantActions({ agent, following, myRole, person }: { agent: boolean; following: boolean; myRole: ShareRole | null; person: SharePerson | null }): ParticipantAction[] {
  const actions: ParticipantAction[] = [following ? 'unfollow' : 'follow'];
  if (agent || myRole !== 'owner' || !person?.manageable) return actions;
  return person.fixedRole ? [...actions, 'remove'] : [...actions, person.role === 'editor' ? 'demote' : 'promote', 'remove'];
}

/** Why someone's view cannot be followed now, or null when it can. */
export function followBlocker({ busy, connected, viewport }: { busy: boolean; connected: boolean; viewport: boolean }): TranslationKey | null {
  return busy ? '#CollabFinishOrCancelChange' : !connected ? '#CollabNoConnection' : !viewport ? '#CollabViewUnavailable' : null;
}
